
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topcamplejeunelawyers",
      function () {
        return require("private-next-pages/topcamplejeunelawyers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topcamplejeunelawyers"])
      });
    }
  